// LivestreamWatermark.jsx
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { EMPTY_OBJECT } from '../resource/defaults.js';

import WatermarkSrc from '../../img/img_watermark.svg';

export const LivestreamWatermark = ({
  videoHeight = 1280,
  videoWidth = 720,
  containerRef = EMPTY_OBJECT,
}) => {
  const [containerSize, setContainerSize] = useState({
    containerWidth: containerRef.current?.clientWidth,
    containerHeight: containerRef.current?.clientHeight,
  });

  useEffect(() => {
    const containerElement = containerRef.current;
    let observer;

    if (containerElement) {
      observer = new ResizeObserver(entries => {
        setContainerSize({
          containerWidth: entries[0].target.clientWidth,
          containerHeight: entries[0].target.clientHeight,
        });
      });
      observer.observe(containerElement);
    }
    return () => {
      observer?.unobserve(containerElement);
    };
  }, [containerRef]);

  return (
    <StyledLivestreamWatermark
      videoWidth={videoWidth}
      videoHeight={videoHeight}
      containerWidth={containerSize.containerWidth}
      containerHeight={containerSize.containerHeight}
    >
      <WatermarkImage
        src={WatermarkSrc}
        alt={'Watermark'}
        isPortrait={videoWidth < videoHeight}
      />
    </StyledLivestreamWatermark>
  );
};

LivestreamWatermark.propTypes = {
  videoHeight: PropTypes.number,
  videoWidth: PropTypes.number,
  containerRef: PropTypes.object,
};

const StyledLivestreamWatermark = styled.div.attrs(
  ({ videoWidth, videoHeight, containerWidth, containerHeight }) => {
    const videoAspectRatio = videoWidth / videoHeight;
    if (!containerWidth || !containerHeight || !videoWidth || !videoHeight)
      return {
        style: {
          aspectRatio: videoAspectRatio,
        },
      };
    const containerAspectRatio = containerWidth / containerHeight;
    return {
      style: {
        aspectRatio: videoAspectRatio,
        width: videoAspectRatio >= containerAspectRatio ? '100%' : 'auto',
        height: videoAspectRatio <= containerAspectRatio ? '100%' : 'auto',
      },
    };
  }
)`
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const WatermarkImage = styled.img`
  position: absolute;
  ${({ isPortrait }) =>
    isPortrait
      ? css`
          top: 14.9%;
          left: 4.2%;
          width: 24%;
          height: auto;
          max-width: 120px;
        `
      : css`
          top: 11.6%;
          left: 2.4%;
          width: auto;
          height: 16%;
          max-height: 100px;
        `};
`;

export default LivestreamWatermark;
